import { RadioProps as MuiRadioProps } from '@mui/material/Radio'
import { UseFormReturn } from 'react-hook-form'

export interface RadioProps extends MuiRadioProps {
  id: string
  methods?: UseFormReturn<any>
  rules?: Record<string, any>
}
